import { render } from "./collapse.vue?vue&type=template&id=7f438a3a&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"

import "./collapse.vue?vue&type=style&index=0&id=7f438a3a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7f438a3a"

export default script